var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEquipment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3333 19.9998V14.6665H30.6666V19.9998",
    stroke: "#1B2559",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3334 20H16.6667C15.5622 20 14.6667 20.8954 14.6667 22V27.3333C14.6667 28.4379 15.5622 29.3333 16.6667 29.3333H31.3334C32.438 29.3333 33.3334 28.4379 33.3334 27.3333V22C33.3334 20.8954 32.438 20 31.3334 20Z",
    stroke: "#1B2559",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3333 29.3335V33.3335H30.6666V29.3335",
    stroke: "#1B2559",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3333 25C29.8855 25 30.3333 24.5523 30.3333 24C30.3333 23.4477 29.8855 23 29.3333 23C28.781 23 28.3333 23.4477 28.3333 24C28.3333 24.5523 28.781 25 29.3333 25Z",
    fill: "#1B2559"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEquipment);
export default __webpack_public_path__ + "static/media/Equipment.2aec365d79b36b6e6b9153a025a37fd9.svg";
export { ForwardRef as ReactComponent };